
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useSimpleAuth } from "@/hooks/useSimpleAuth";

export default function Auth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated } = useSimpleAuth();

  useEffect(() => {
    const checkAuth = async () => {
      if (isAuthenticated()) {
        console.log('Auth: Usuário já autenticado, redirecionando para /admin');
        navigate("/admin");
      }
      setIsChecking(false);
    };

    checkAuth();
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const success = await login(email, password);
      if (success) {
        console.log('Login bem-sucedido, redirecionando para /admin');
        localStorage.setItem("isAuthenticated", "true");
        toast.success("Login realizado com sucesso!");
        
        // Redireciona para a página anterior ou para /admin
        const from = location.state?.from || "/admin";
        navigate(from, { replace: true });
      }
    } catch (error) {
      console.error('Erro no login:', error);
      toast.error("Erro ao fazer login. Verifique suas credenciais.");
      localStorage.removeItem("isAuthenticated");
    } finally {
      setIsLoading(false);
    }
  };

  if (isChecking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-2">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container max-w-md mx-auto py-8 px-4">
      <div className="border rounded-lg p-6 space-y-4">
        <h1 className="text-2xl font-bold text-center">Área Administrativa</h1>
        <p className="text-muted-foreground text-center">
          Digite suas credenciais para acessar a área administrativa
        </p>
        
        <form onSubmit={handleLogin} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">E-mail</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Digite seu e-mail"
              required
              disabled={isLoading}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Senha</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite sua senha"
              required
              disabled={isLoading}
            />
          </div>
          
          <Button 
            type="submit" 
            className="w-full"
            disabled={isLoading}
          >
            {isLoading ? (
              <span>Carregando...</span>
            ) : (
              <>
                <LogIn className="w-4 h-4 mr-2" />
                Entrar
              </>
            )}
          </Button>
        </form>
      </div>
    </div>
  );
}
